import { geneUrl } from '../lib/memegenes';
import { GeneCheckIcon } from './GeneCheckIcon';

/**
 * "Verified by MemeGenes" — present but not in-your-face. A visible, tappable
 * link that opens the original's Gene page on MemeGenes. The original stays the
 * hero; this rides quietly beneath it. See BRAND.md ▸ Relationship to MemeGenes.
 */
export function VerifiedBadge({ geneId }: { geneId: string }) {
  return (
    <a
      href={geneUrl(geneId)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      className="inline-flex items-center gap-1.5 text-xs text-provny-muted transition-colors hover:text-provny-gold"
    >
      <GeneCheckIcon size={14} />
      Verified by MemeGenes
    </a>
  );
}
